import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Button } from 'reactstrap';
import colors from 'src/styles/equalution/colors';

import CoachingIcon from 'src/assets/icons/coaching.svg';
import OfferIcon from 'src/assets/icons/offer.svg';
import { BackButton } from 'src/components/back-button/BackButton';
import { isUserFromAustralia } from 'src/lib/utils';

interface CoachUpsellCardProps {
  price?: number | string;
  onAddCoach?: () => void;
  onSkip?: () => void;
  onBack: () => void;
}

const CoachUpsellCard: React.FC<CoachUpsellCardProps> = ({
  price = '',
  onAddCoach,
  onSkip,
  onBack,
}) => {
  // Only show personal coaching to Australian users
  if (!isUserFromAustralia()) {
    return null;
  }

  const BackButtonWhite = () => (
    <IconButton
      sx={{
        position: 'absolute',
        left: 45,
        top: -25,
        backgroundColor: colors.WHITE,
        height: 40,
        width: 40,
        borderRadius: 20,
      }}>
      <BackButton onPress={onBack} />
    </IconButton>
  );
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 520,
        margin: '0 auto',
        textAlign: 'center',
        paddingTop: '32px',
      }}>
      <BackButtonWhite />
      <img src={OfferIcon} alt="Offer" />

      <Typography
        sx={{
          fontSize: '22px',
          fontWeight: 700,
          color: colors.OFF_BLACK,
          marginTop: 2,
        }}>
        Level up with 1:1 Nutrition Coaching
      </Typography>
      <Typography
        sx={{
          fontSize: '22px',
          fontWeight: 700,
          color: colors.OFF_BLACK,
          marginBottom: 3,
        }}>
        for just{' '}
        <span style={{ fontSize: '26px' }}>${Number(price).toFixed(0)}</span>{' '}
        (recommended)
      </Typography>

      <Box
        sx={{
          backgroundColor: colors.OFF_WHITE,
          padding: '12px 12px 24px 12px',
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Box>
          <img src={CoachingIcon} alt="Coach Icon" width={60} height={60} />
        </Box>

        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.SALAD,
            marginBottom: 2,
            width: '64%',
          }}>
          Lose weight faster with expert accountability
        </Typography>

        <Box
          sx={{
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            marginBottom: 2,
          }}>
          {[
            'Members with coaching stay more consistent and reach their goals sooner.',
            'Real-time support from our qualified nutrition experts',
            'Additional meal plan adjustments when you need them',
          ].map(item => (
            <Box key={item} sx={{ display: 'flex', alignItems: 'center' }}>
              <CheckIcon sx={{ color: colors.SALAD, fontSize: 20, mr: 1 }} />
              <Typography
                sx={{
                  fontSize: '16px',
                  color: colors.OFF_BLACK,
                }}>
                {item}
              </Typography>
            </Box>
          ))}
        </Box>

        <Typography
          sx={{
            fontSize: '12px',
            color: colors.OFF_BLACK,
            marginBottom: 2,
            marginTop: 3,
          }}>
          Valid for the challenge duration only
        </Typography>

        <Button
          onClick={onAddCoach}
          style={{
            fontWeight: 600,
            fontSize: '20px',
            width: '350px',
          }}>
          Add a nutrition coach
        </Button>
      </Box>

      <Button
        onClick={onSkip}
        style={{
          backgroundColor: 'transparent',
          borderColor: colors.SALAD,
          color: colors.SALAD,
          fontWeight: 600,
          width: '350px',
          marginTop: '24px',
        }}>
        Skip
      </Button>
      <Box height={'100px'} />
    </Box>
  );
};

export default CoachUpsellCard;
